import * as React from 'react'
import { useState } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import SpinnerOverlay from '../../../../components/shared/spinner_overlay'
import WarehouseCalendarTable from './calendar_table'
import OverviewCalendarTable from './overview_calendar_table'
import { Element, RentList, RentItem } from './warehouse_rent_list_types'

interface WarehouseRentListProps {
  loadData: (data: {
    rentList: RentList
    startDate: string
    endDate: string
    groupedAvailableElements: Record<string, Element[]>
    elementGroups: Record<string, string>
    rentedItems: Record<string, RentItem[]>
  }) => void
  rentElement: (rentListId: number, elementId: number, warehouseId: number, quantity: number) => void
  clearErrors: () => void
  initialWarehouseRentList?: RentList | null
  rentElementRequestInProgress: boolean
  rentedItems: Record<string, RentItem[]>
  groupedAvailableElements: Record<string, Element[]>
  elementGroups: Record<string, string>
  errors: string[]
  warehouseId: number
  isOverview?: boolean
  initialRentedItems?: Record<string, RentItem[]> | null
}

const WarehouseRentList: React.FC<WarehouseRentListProps> = ({
  loadData,
  rentElement,
  clearErrors,
  errors,
  rentElementRequestInProgress,
  rentedItems,
  groupedAvailableElements,
  elementGroups,
  warehouseId,
  isOverview,
  initialWarehouseRentList,
  initialRentedItems,
}) => {
  const { I18n } = window as any
  const [rentListData, setRentListData] = useState<RentList | null>(initialWarehouseRentList)

  React.useEffect(() => {
    if (initialWarehouseRentList && initialRentedItems) {
      loadData({
        rentList: initialWarehouseRentList,
        startDate: initialWarehouseRentList.startDate,
        endDate: initialWarehouseRentList.endDate,
        groupedAvailableElements: initialWarehouseRentList.groupedAvailableElements || {},
        elementGroups: initialWarehouseRentList.elementGroups || {},
        rentedItems: initialRentedItems,
      })
      setRentListData(initialWarehouseRentList)
    }
  }, [initialWarehouseRentList, initialRentedItems])

  if (!rentListData) {
    return null
  }

  const { startDate, endDate } = rentListData

  const handleElementClick = (element: Element, quantity: number) => {
    if (!isOverview) {
      rentElement(rentListData.id, element.id, warehouseId, quantity)
    }
  }

  return (
    <div className="rent-list">
      <Modal isOpen={errors && errors.length > 0} toggle={clearErrors} size="lg">
        <ModalHeader toggle={clearErrors}>{I18n.t('elements.rent_list.error_modal_header')}</ModalHeader>
        <ModalBody>{errors ? errors.join('. ') : ''}</ModalBody>
      </Modal>
      <SpinnerOverlay isActive={rentElementRequestInProgress}>
        {isOverview ? (
          <OverviewCalendarTable
            startDate={startDate}
            endDate={endDate}
            groupedAvailableElements={groupedAvailableElements || rentListData.groupedAvailableElements || {}}
            elementGroups={elementGroups || rentListData.elementGroups || {}}
            rentedItems={rentedItems || rentListData.rentedItems || {}}
            rentList={rentListData}
          />
        ) : (
          <WarehouseCalendarTable
            startDate={startDate}
            endDate={endDate}
            groupedAvailableElements={groupedAvailableElements || rentListData.groupedAvailableElements || {}}
            elementGroups={elementGroups || rentListData.elementGroups || {}}
            handleElementClick={handleElementClick}
            rentedItems={rentedItems || rentListData.rentedItems || {}}
            rentList={rentListData}
          />
        )}
      </SpinnerOverlay>
    </div>
  )
}

WarehouseRentList.defaultProps = {
  initialWarehouseRentList: null,
  initialRentedItems: null,
  isOverview: false,
}

export default WarehouseRentList
